import { requireField } from './validators';

export default class SafeguardingEvent {
  constructor(data = {}) {
    requireField(data.type, 'safeguarding.type');
    requireField(data.severity, 'safeguarding.severity');
    requireField(data.status, 'safeguarding.status');
    requireField(data.date, 'safeguarding.date');

    this.id = data.id || `saf-${Math.random().toString(36).slice(2, 9)}`;
    this.category = data.category || 'Social Care';
    this.type = data.type;
    this.severity = data.severity;
    this.status = data.status;
    this.description = data.description || '';
    this.date = data.date;
    this.assignedOwner = data.assignedOwner || '';
    this.reviewDate = data.reviewDate || null;
    this.escalationLevel = data.escalationLevel || 'L1';
    this.attachments = data.attachments || [];
    this.createdBy = data.createdBy || 'System';
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || this.createdAt;
    this.visibility = data.visibility || ['Admin', 'Manager', 'Staff'];
  }

  toJSON() {
    return { ...this };
  }
}
